
export const PRODUCT_LOAD = 'PRODUCT_LOAD';


export const receive = (product) => ({
    type: PRODUCT_LOAD,
    payload: product,    
})